import React, { PropTypes } from 'react'

ValidationError.propTypes = {
  error: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
}

ValidationError.defaultProps = {
  error: "",
  type: 'error'
}

const styles = {
  warning: {
    fontSize: '13px',
    fontStyle: 'italic',
    color: '#a94442'
  },
  error: {
    fontSize: '13px',
    fontStyle: 'italic',
    color: '#a94442'
  }
}

export default function ValidationError ({ error, type }) {
  return (
    <p style={styles[type]}>{error}</p>
  )
}


// WEBPACK FOOTER //
// ./src/app/components/validation-error.js